'use client';
import React from 'react';
import Script from 'next/script';

const GoogleAnalytics = ({ measurementId } : {measurementId: string}) => {
  return (
    <>
      <Script id={'googleTagManager'} async={true} strategy='afterInteractive' src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`} />
      {process.env.APP_ENV === 'production'
        ? (
          <Script
            id={'googleAnalyzer'}
            async={true}
            strategy='afterInteractive'
            dangerouslySetInnerHTML={{
              __html: `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('consent', 'default', {
              'ad_user_data': 'denied',
              'ad_personalization': 'denied',
              'ad_storage': 'denied',
              'analytics_storage': 'denied',
                });
            gtag('config', 'G-Z3SVP8E8H2', { 'allow_enhanced_conversions':true });` }}
          />
        ) : null}
    </>
  );
};

export default GoogleAnalytics;
